import * as React from 'react';

import { AvoidWidowText } from 'shared-react';
import './FormTitle.scss';

interface FormTitleProps {
  text: string;
}

const FormTitle = ({ text }: FormTitleProps) => (
  <h1 className="FormTitle">
    <AvoidWidowText text={text} />
  </h1>
);

export default FormTitle;
